import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { PRODUCTS_HREF, PRODUCT_GROUPS, ProductMenuItem } from './productMenuData';
function SubItem({
  item
}: {
  item: ProductMenuItem;
}) {
  if (!item.href) {
    return <span aria-disabled="true" className="block px-4 py-2 text-sm text-brand-darkGold/60 cursor-not-allowed select-none" data-id="element-126">
        {item.label}
      </span>;
  }
  return <a href={item.href} className="block px-4 py-2 text-sm text-brand-red hover:bg-brand-gray transition-colors" data-id="element-127">
      {item.label}
    </a>;
}
export function ProductsMenuDesktop() {
  return <li className="group relative" data-id="element-128">
      <a href={PRODUCTS_HREF} className="hover:text-brand-red transition-colors flex items-center gap-1" data-id="element-129">
        PRODUCTS
        <ChevronDown className="w-3.5 h-3.5" data-id="element-130" />
      </a>

      {/* First-level dropdown: the five product groups */}
      <div className="absolute top-full left-0 mt-0 w-56 bg-white border border-gray-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible transition-all z-50" data-id="element-131">
        <ul className="py-2 text-sm font-normal text-brand-charcoal" data-id="element-132">
          {PRODUCT_GROUPS.map(grp => <li key={grp.label} className="group/grp relative" data-id="element-133">
              {grp.href ? <a href={grp.href} className="flex items-center justify-between px-4 py-2 hover:bg-brand-gray hover:text-brand-red transition-colors" data-id="element-134">
                  <span data-id="element-135">{grp.label}</span>
                  <ChevronRight className="w-3.5 h-3.5 flex-shrink-0" data-id="element-136" />
                </a> : <div className="flex items-center justify-between px-4 py-2 hover:bg-brand-gray cursor-default transition-colors" data-id="element-137">
                  <span data-id="element-138">{grp.label}</span>
                  <ChevronRight className="w-3.5 h-3.5 flex-shrink-0" data-id="element-139" />
                </div>}

              {/* Nested flyout */}
              <div className="absolute top-0 left-full ml-0 w-60 bg-white border border-gray-200 shadow-lg opacity-0 invisible group-hover/grp:opacity-100 group-hover/grp:visible group-focus-within/grp:opacity-100 group-focus-within/grp:visible transition-all z-50" data-id="element-140">
                <ul className="py-2" data-id="element-141">
                  {grp.items.map(item => <li key={item.label} data-id="element-142">
                      <SubItem item={item} data-id="element-143" />
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>
      </div>
    </li>;
}